module.exports = __webpack_public_path__ + "media/svg/bq-66ea2e65.svg";